// import React from 'react';
// import '../Styles/Asking.css';
// import logo from '../Images/SAVI AI full.png'
// import { useNavigate } from 'react-router-dom';
// import { useEffect } from 'react';

// const Asking = () => {
//   const navigate = useNavigate();

//   const handlesignin = () => {
//     navigate('/signin-type');
//   }

//   const handlesignup = () => {
//     navigate('/register')
//   }
//   useEffect(() => {
//     const savedTheme = localStorage.getItem('theme') || 'light';
//     document.documentElement.setAttribute('data-theme', savedTheme);
//   }, []);
//   useEffect(() => {
//     // Set theme on mount
//     const setTheme = () => {
//       const savedTheme = localStorage.getItem('theme') || 'light';
//       document.documentElement.setAttribute('data-theme', savedTheme);
//     };
//     setTheme();

//     // Listen for theme changes in other tabs/components
//     const handleStorage = (e) => {
//       if (e.key === 'theme') {
//         setTheme();
//       }
//     };
//     window.addEventListener('storage', handleStorage);

//     return () => window.removeEventListener('storage', handleStorage);
//   }, []);
//   return (
//     <div className="asking-main-container">
//       <header className="asking-header">
//         <div className="asking-logo">
//           <img src={logo} alt="Logo" className="asking-logo-image" />
//         </div>
//       </header>

//       <div className="asking-content-container">
//         <div className="asking-welcome-box">
//           <h1 className="asking-title">
//             Welcome to <span className="asking-title-highlight">Savi</span>
//           </h1>
//           <p className="asking-description">
//             Join thousands of users and access all our features.
//           </p>

//           <div className="asking-buttons-container">
//             <button className="asking-signin-button" onClick={handlesignin}>
//               Sign In
//             </button>
//             <button className="asking-signup-button" onClick={handlesignup}>
//               Sign Up
//             </button>
//           </div>

//           <div className="asking-info-text">
//             New here? Create an account to get started.
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Asking;




import React from 'react';
import '../Styles/Asking.css';
import logo from '../Images/SAVI AI full.png'
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const Asking = () => {
  const navigate = useNavigate();

  const handlesignin = () => {
    navigate('/login');
  }

  const handlesignup = () => {
    navigate('/register')
  }
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);
  useEffect(() => {
    // Set theme on mount
    const setTheme = () => {
      const savedTheme = localStorage.getItem('theme') || 'light';
      document.documentElement.setAttribute('data-theme', savedTheme);
    };
    setTheme();

    // Listen for theme changes in other tabs/components
    const handleStorage = (e) => {
      if (e.key === 'theme') {
        setTheme();
      }
    };
    window.addEventListener('storage', handleStorage);

    return () => window.removeEventListener('storage', handleStorage);
  }, []);
  return (
    <div className="asking-main-container">
      <header className="asking-header">
        <div className="asking-logo">
          <img src={logo} alt="Logo" className="asking-logo-image" />
        </div>
      </header>

      <div className="asking-content-container">
        <div className="asking-welcome-box">
          <h1 className="asking-title">
            Welcome to <span className="asking-title-highlight">Savi</span>
          </h1>
          <p className="asking-description">
            Join thousands of users and access all our features.
          </p>

          <div className="asking-buttons-container">
            <button className="asking-signin-button" onClick={handlesignin}>
              Sign In
            </button>
            <button className="asking-signup-button" onClick={handlesignup}>
              Sign Up
            </button>
          </div>

          <div className="asking-info-text">
            New here? Create an account to get started.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Asking;